export default __webpack_public_path__ + "static/media/H1015.1.da99223b.mp3";